import { Copyright, LegalInfo, MediaIcon, MediaIcons, MediaWrapper, Nav, StyledLink, Wrapper } from "./footer.styles";
import { ReactComponent as VkIcon } from "assets/icons/vk2.svg";
import { ReactComponent as TgIcon } from "assets/icons/tg2.svg";
import { Typography } from "@atoms";
import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const {t} = useTranslation();

  return (
    <Wrapper>
      <MediaWrapper>
        <Typography>{t("ourSocials")}</Typography>
        <MediaIcons>
          <a href="https://t.me/myft_ru"><MediaIcon><TgIcon /></MediaIcon></a>
          <a href="https://vk.com/public220419224"><MediaIcon><VkIcon /></MediaIcon></a>
        </MediaIcons>
      </MediaWrapper>
      <Nav>
        <Typography>
          <StyledLink to="/my-stories">
            {t("myStories")}
          </StyledLink>
        </Typography>
        {/*<Typography>*/}
        {/*  <StyledLink to="/stories">*/}
        {/*    {t("stories")}*/}
        {/*  </StyledLink>*/}
        {/*</Typography>*/}
        <Typography>
          <StyledLink to="/profile">
            {t("profile")}
          </StyledLink>
        </Typography>
        <Typography>
          <StyledLink to="/feedback">
            {t("feedback")}
          </StyledLink>
        </Typography>
      </Nav>
      <LegalInfo>
        <Typography>
          <StyledLink to="/policy">
            {t("privacyPolicy")}
          </StyledLink>
        </Typography>
        <Typography>
          <StyledLink to="/policy">
            {t("publicOffer")}
          </StyledLink>
        </Typography>
        <Copyright>
          © myft 2025
        </Copyright>
      </LegalInfo>
    </Wrapper>
  );
};

export default Footer;
